import React from "react";

import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

import SvgI24Publish from "assets/icons/I24Publish";

import {
  PUBLISH_STATUSES,
  PUBLISH_STATUSES_TEXT,
  PUBLISH_STATUSES_BUTTON_TEXT,
  ACTIVE_PROGRAM_TYPE,
  ACTIVE_PROGRAM_TYPE_TEXT,
} from "constants/models";

export const getPublishButtonTextManualBadge = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES_BUTTON_TEXT.DRAFT_MANUAL_BADGE;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES_BUTTON_TEXT.PUBLISHED;
  }
};
export const getPublishButtonText = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES_BUTTON_TEXT.DRAFT;
    case PUBLISH_STATUSES.PREVIEW:
      return PUBLISH_STATUSES_BUTTON_TEXT.PREVIEW;
    case PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE:
      return PUBLISH_STATUSES_BUTTON_TEXT.SCHEDULE_FOR_REMOVE;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES_BUTTON_TEXT.PUBLISHED;
  }
};

export const getPublishButtonTextWithout = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES_BUTTON_TEXT.DRAFT;
    case PUBLISH_STATUSES.PREVIEW:
      return PUBLISH_STATUSES_BUTTON_TEXT.SCHEDULE_FOR_REMOVE;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES_BUTTON_TEXT.PUBLISHED;
  }
};

export const getPublishButtonIcon = (publishStatus: string) => {
  if (
    [PUBLISH_STATUSES.DRAFT, PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE].includes(
      publishStatus,
    )
  ) {
    return <SvgI24Publish />;
  } else {
    return <RemoveCircleOutlineIcon />;
  }
};

export const getPublishStatusText = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES_TEXT.DRAFT;
    case PUBLISH_STATUSES.PREVIEW:
      return PUBLISH_STATUSES_TEXT.PREVIEW;
    case PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE:
      return PUBLISH_STATUSES_TEXT.SCHEDULE_FOR_REMOVE;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES_TEXT.PUBLISHED;
  }
};

export const getActiveProgramTypeText = (activeProgramType: string) => {
  switch (activeProgramType) {
    case ACTIVE_PROGRAM_TYPE.COMMON:
      return ACTIVE_PROGRAM_TYPE_TEXT.COMMON;
    case ACTIVE_PROGRAM_TYPE.VIP:
      return ACTIVE_PROGRAM_TYPE_TEXT.VIP;
    case ACTIVE_PROGRAM_TYPE.SPECIAL:
      return ACTIVE_PROGRAM_TYPE_TEXT.SPECIAL;
    case ACTIVE_PROGRAM_TYPE.COACH:
      return ACTIVE_PROGRAM_TYPE_TEXT.COACH;
  }
};

export const getNextPublishStatus = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES.PREVIEW;
    case PUBLISH_STATUSES.PREVIEW:
      return PUBLISH_STATUSES.DRAFT;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE;
    case PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE:
      return PUBLISH_STATUSES.PUBLISHED;
  }
};

export const getNextPublishStatusWithoutScheduled = (publishStatus: string) => {
  switch (publishStatus) {
    case PUBLISH_STATUSES.DRAFT:
      return PUBLISH_STATUSES.PREVIEW;
    case PUBLISH_STATUSES.PREVIEW:
      return PUBLISH_STATUSES.PUBLISHED;
    case PUBLISH_STATUSES.PUBLISHED:
      return PUBLISH_STATUSES.DRAFT;
  }
};

export const getConfirmArchivationText = ({
  entity,
  suffix,
}: {
  entity: any;
  suffix: string;
}) => {
  const name = [entity.title, suffix].join(" ");
  const isPublished = [
    PUBLISH_STATUSES.PUBLISHED,
    PUBLISH_STATUSES.SCHEDULE_FOR_REMOVE,
  ].includes(entity.publishStatus);

  return !isPublished
    ? `Are you sure you want to archive ${name}? It will be moved to the Archive in the Admin panel.`
    : `Are you sure you want to archive ${name}? It will no longer be displayed to app users in production and moved to the Archive in the Admin panel.`;
};
